export default __webpack_public_path__ + "static/media/clio-large.ce7f0a69.jpg";